import React from 'react'
import PropTypes from 'prop-types'

import createSearchResultBodyContainer from '../../../containers/searchResultBodyContainer'
import { getConfigBySite } from '../../../../config/sites'
import { reportProductsImpressions } from '../../../../common/analytics/resultAnalytics'
import ProductList from '../../../components/productList'
import {
  itemDecorator,
  isSearchResultMatchesEqual
} from '../../../../common/utils/item'
import { getTopLevelRoute } from '../../../../common/utils/urlHelper'

class SearchResultBody extends React.Component {
  itemRankOffset() {
    const { currentSite, location } = this.props

    const pageSize = getConfigBySite(currentSite, 'common.search_page_size')

    return ((Number(location.query.page) || 1) - 1) * pageSize + 1
  }

  componentDidMount() {
    const { matches, currentSite, location, clientVersion } = this.props

    // only report product impressions at page initial rendering for client that is not 2
    if (clientVersion !== 2) {
      reportProductsImpressions({
        items: matches,
        currentSite,
        itemRankOffset: this.itemRankOffset(),
        page: 'Search Results',
        section: getTopLevelRoute(location.pathname)
      })
    }
  }

  componentDidUpdate(prevProps) {
    const prevMatches = prevProps.matches
    const {
      matches,
      currentSite,
      location,
      clientFinishedLoading,
      clientVersion
    } = this.props

    // only report again when search result change or client finished loading
    if (
      !isSearchResultMatchesEqual(prevMatches, matches) ||
      (clientVersion === 2 &&
        prevProps.clientFinishedLoading !== clientFinishedLoading)
    ) {
      reportProductsImpressions({
        items: matches,
        currentSite,
        itemRankOffset: this.itemRankOffset(),
        page: 'Search Results',
        section: getTopLevelRoute(location.pathname)
      })
    }
  }

  render() {
    const {
      matches,
      createFavoriteCollection,
      currentSite,
      collections,
      cartItems,
      token,
      deleteBookmark,
      addBookmark,
      favoriteCollectionID,
      openModal,
      location,
      preferences,
      muteVideo
    } = this.props

    return (
      <div data-test-selector="search-results-default">
        <ProductList
          items={matches}
          currentSite={currentSite}
          preferences={preferences}
          muteVideo={muteVideo}
          location={location}
          itemDecorator={itemDecorator(
            currentSite,
            openModal,
            !token,
            favoriteCollectionID,
            collections,
            deleteBookmark,
            addBookmark,
            createFavoriteCollection,
            this.itemRankOffset(),
            cartItems,
            location
          )}
        />
      </div>
    )
  }
}

SearchResultBody.propTypes = {
  matches: PropTypes.array.isRequired,
  view: PropTypes.string
}

export default createSearchResultBodyContainer(SearchResultBody)



// WEBPACK FOOTER //
// ./client/pages/search/result/searchResultBody.js